
import { FlagFilled, MoreOutlined } from '@ant-design/icons';
import { Button as AntdButton, Checkbox, DatePicker, Dropdown, Menu, Modal } from 'antd';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import QRCode from 'react-qr-code';
import { useEffect, useRef, useState } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { connect } from 'react-redux';
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
    Card, CardBody,
    CardHeader,
    CardTitle, Table
} from 'reactstrap';
import { GetRecords } from "../../../redux/actions/forms";
import FormService from "../../../redux/services/forms";

import { DeleteOutlined, LoadingOutlined, UndoOutlined } from '@ant-design/icons';

import Box from '../primitive/Box';
import Button from '../primitive/Button';
import Check from '../primitive/Check';
import Drop from '../primitive/Drop';
import Image from '../primitive/Image';
import Input from '../primitive/Input';
import Label from '../primitive/Label';
import List from '../primitive/List';

import Radio from '../primitive/Radio';
import Signature from './components/Signature';
import Snapshot from './components/Snapshot';
import DisplayManager from './display_manager';


import axios from "axios";
import authHeader from "../../../redux/services/auth-header";
import { formsUrl } from "../../../redux/services/base";
import database from '../../firebasedb';
import process_vars from '../../forms/intermediate/process_vars';
import InputTable, { process_table_vars, renderTableLabelText } from '../records/components/InputTable';

const math = require('mathjs');


const contentFor = async (record, page) => {
    let components_render = [];
    let components = record.content;
    let vars = record.vars;
    for (let k = 0; k < components.length; ++k) {
        if (components[k].page === page) {
            if (components[k].type === 'primitive/Box') {
                components_render.push(
                    <Box id={k} key={k} comps={components} vw={window.innerWidth} vars={vars} />
                );
            } else if (components[k].type === 'primitive/Label') {
                components_render.push(
                    <Label id={k} key={k} comps={components} vw={window.innerWidth} vars={vars} pdf={true} />
                );
            } else if (components[k].type === 'primitive/Button') {
                components_render.push(<Button key={k} id={k} comps={components} vw={window.innerWidth} vars={vars} />);
            } else if (components[k].type === 'primitive/Input') {
                components_render.push(<Input id={k} key={k} comps={components} vw={window.innerWidth} vars={vars} pdf={true} />);
            } else if (components[k].type === 'primitive/List') {
                components_render.push(
                    <List id={k} key={k} comps={components} vw={window.innerWidth} vars={vars} pdf={true} />
                );
            } else if (components[k].type === 'primitive/Check') {
                components_render.push(
                    <Check id={k} key={k} comps={components} vw={window.innerWidth} vars={vars} pdf={true} />
                );
            } else if (components[k].type === 'primitive/Radio') {
                let rad = <Radio id={k} key={k} comps={components} vw={window.innerWidth} vars={vars} pdf={true} />;

                components_render.push(rad);
            } else if (components[k].type === 'primitive/Drop') {
                components_render.push(
                    <Drop id={k} key={k} comps={components} vw={window.innerWidth} vars={vars} pdf={true} />
                );
            } else if (components[k].type === 'primitive/Image') {
                components_render.push(
                    <Image id={k} key={k} comps={components} vw={window.innerWidth} vars={vars} pdf={true} />
                );
            } else if (components[k].type === 'intermediate/Signature') {
                if (components[k].props.image_id != null && components[k].props.image_id != undefined) {
                    const resp = await axios.get(`${formsUrl}/records/image/${components[k].props.image_id}/get/`, { headers: authHeader() });
                    if (resp.status == 200) {
                        var s3ImageUrl = resp.data.image;
                        var sigData = await fetch(s3ImageUrl)
                            .then(response => response.blob())
                            .then(blob => {
                                return new Promise((resolve, reject) => {
                                    const reader = new FileReader();
                                    reader.onloadend = () => resolve(reader.result.split(',')[1]);
                                    reader.onerror = reject;
                                    reader.readAsDataURL(blob);
                                });
                            })
                            .then(base64Data => {
                                return `data:image/png;base64,${base64Data}`;
                            })
                            .catch(error => {
                                console.error('Error fetching or converting image:', error);
                                return null;
                            });

                        if (sigData != null) {
                            components[k].props.data = sigData;
                        }
                    }
                }
                components_render.push(
                    <Signature key={k} id={k} comps={components} vw={0.9 * window.innerWidth} vars={vars} pdf={true} />
                );
            } else if (components[k].type === 'intermediate/InputTable') {
                let tab = <InputTable key={k} id={k} comps={components} vw={0.9 * window.innerWidth} vars={vars} pdf={true} />;
                components_render.push(tab);
            }
            else if (components[k].type === 'intermediate/Snapshot') {
                if (components[k].image_id != null && components[k].image_id != undefined) {
                    const resp = await axios.get(`${formsUrl}/records/image/${components[k].image_id}/get/`, { headers: authHeader() });
                    if (resp.status == 200) {
                        var s3ImageUrl = resp.data.image;

                        var sigData = await fetch(s3ImageUrl)
                            .then(response => response.blob())
                            .then(blob => {
                                return new Promise((resolve, reject) => {
                                    const reader = new FileReader();
                                    reader.onloadend = () => resolve(reader.result.split(',')[1]);
                                    reader.onerror = reject;
                                    reader.readAsDataURL(blob);
                                });
                            })
                            .then(base64Data => {
                                return `data:image/png;base64,${base64Data}`;
                            })
                            .catch(error => {
                                console.error('Error fetching or converting image:', error);
                                return null;
                            });
                        if (sigData != null) {
                            components[k].data = sigData;
                        }
                    }
                }
                components_render.push(
                    <Snapshot id={k} comps={components}
                        vw={0.9 * window.innerWidth} vars={vars} pdf={true} />
                );
            }
        }
    }

    // console.log('Page > height  > ', (record.pages[page].height));
    // console.log('Page height > ', (record.pages[page].height * 90));
    return <div style={{
        position: 'relative',
        background: '#ffffff',
        width: '100vw',
        height: (record.pages[page].height * 100).toString() + 'vw',
        // margin: '2.5vmax',
        // marginTop: '20px'
    }}>{components_render}</div>;
}



const Records = (props) => {
    const { formId, formName } = useParams();
    const history = useHistory();
    const location = useLocation();
    const downloadRef = useRef();
    const downloadRef1 = useRef();

    const [loading, setLoading] = useState(false);
    const [showDisplayModal,setShowDisplayModal] = useState(null);

    useEffect(() => {
        // Reference to the desired location in your Realtime Database
        const databaseRef = database.ref('/records');

        // Event listener for 'value' changes in the database
        const onDataChange = (snapshot) => {
            const newData = snapshot.val();
            console.log('newData > ', newData);
            getRecords("", false);
            //   setData(newData);
        };

        // Set up the listener
        databaseRef.on('value', onDataChange);

        // Clean up the listener when the component is unmounted
        return () => {
            databaseRef.off('value', onDataChange);
        };
    }, []);

    const getRecords = (url, showLoader) => {
        let _formId = formId;
        if (props?.formId != null) {
            _formId = props?.formId;
        }
        if (showLoader)
            setLoading(true);
        let payload = {
            "formId": formId,
            "formType": props?.formType
        };
        if (props?.basicRecordInfo == true) {
            payload["basicRecordInfo"] = true;
        }

        if (props?.filters != null && props?.filters != undefined) {
            payload = props?.filters;
            if (payload?.selectedFormId != formId) {
                payload = {
                    "formId": payload?.formId,
                };
            }
            if (props?.basicRecordInfo == true) {
                payload["basicRecordInfo"] = true;
            }
            payload["formId"] = formId;
            if (payload?.flag != null) {
                if (typeof (payload?.flag) == 'string') {
                    payload["flag"] = payload?.flag;
                }
                else {
                    payload["flag"] = payload?.flag?.join(",");
                }
            }

            payload["formType"] = props?.formType;
            // New Code added
            console.log(payload);
        }
        props.dispatch(GetRecords(payload, url)).then(res => {
            if (showLoader)
                setLoading(false);
        });
    }

    useEffect(() => {
        getRecords("", true);

    }, [props?.filters, props?.formType, props?.refresh])

    const [showPDFModal, setShowPDFModal] = useState(false);

    const [pdfPages, setPdfPages] = useState([]);

    // Record selected for the "Generate QR" modal (null = closed).
    const [qrRecord, setQrRecord] = useState(null);

    // CSV export options dialog.
    const [showCsvOptions, setShowCsvOptions] = useState(false);
    const [csvRange, setCsvRange] = useState(null); // [moment start, moment end] or null
    const [csvSelected, setCsvSelected] = useState(null); // included component names
    const [csvComponents, setCsvComponents] = useState([]); // [{ key, name, label, page, type }]
    const [activeCsvPage, setActiveCsvPage] = useState(0); // which page tab is open

    // Add/remove a set of component keys from the CSV selection.
    const toggleCsvKeys = (keys, on) => {
        const cur = new Set(csvSelected || []);
        keys.forEach((k) => { if (on) cur.add(k); else cur.delete(k); });
        setCsvSelected([...cur]);
    };

    // A stable, unique key for a component: its creation_index when available
    // (names aren't unique), else its position in the content array.
    const compKey = (el, idx) =>
        (el && el.creation_index !== undefined && el.creation_index !== null)
            ? `ci-${el.creation_index}` : `ix-${idx}`;

    const isExportable = (el) =>
        ['primitive/Input', 'primitive/Radio', 'primitive/Check', 'primitive/Drop', 'intermediate/InputTable'].includes(el.type)
        || (el.type === 'primitive/Label' && el?.props?.appearsInCSV);

    // Components eligible for CSV columns, derived from a record's content.
    // Duplicate names get a "#n" suffix so they can be told apart.
    const exportableComponentsFromContent = (content) => {
        const list = [];
        (content || []).forEach((el, idx) => {
            if (isExportable(el)) {
                list.push({ key: compKey(el, idx), name: el.name || '(unnamed)', page: (el.page ?? 0), type: el.type });
            }
        });
        const counts = {};
        list.forEach((c) => { counts[c.name] = (counts[c.name] || 0) + 1; });
        const seen = {};
        list.forEach((c) => {
            if (counts[c.name] > 1) {
                seen[c.name] = (seen[c.name] || 0) + 1;
                c.label = `${c.name} #${seen[c.name]}`;
            } else {
                c.label = c.name;
            }
        });
        return list;
    };

    // Opens the export dialog, fetching one full record to populate the
    // component checklist (the list view's records may omit `content`).
    const openCsvOptions = async () => {
        setCsvRange(null);
        let list = [];
        try {
            setLoading(true);
            const records = await FormService.getRecords({
                "formId": formId,
                "formType": props?.formType,
                "page_size": 1,
                "basicRecordInfo": false
            });
            if (records?.results?.length > 0) {
                list = exportableComponentsFromContent(records.results[0].content);
            }
        } catch (e) {
            // ignore; dialog still opens with whatever was found
        }
        setLoading(false);
        setCsvComponents(list);
        setCsvSelected(list.map((c) => c.key)); // all selected by default
        setActiveCsvPage(list.length ? Math.min(...list.map((c) => c.page)) : 0);
        setShowCsvOptions(true);
    };

    // Same URL as the "Copy Link" action.
    const recordUrl = (r) => `${window.location.origin}/forms/${r.form}/records/${r.record_id}/change`;

    // Render the QR to an SVG string in memory (independent of the on-screen
    // modal), used for the PNG raster, the print view, and the SVG fallback.
    const buildQrSvgMarkup = (url) =>
        renderToStaticMarkup(<QRCode value={url || ''} size={1024} bgColor="#ffffff" fgColor="#000000" />);

    const svgToDataUrl = (svgMarkup) =>
        'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgMarkup);

    // Rasterize the QR SVG to a PNG data URL (white background, square).
    const buildQrPngDataUrl = (url) => new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            try {
                const size = 1024;
                const canvas = document.createElement('canvas');
                canvas.width = size;
                canvas.height = size;
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, size, size);
                ctx.drawImage(img, 0, 0, size, size);
                resolve(canvas.toDataURL('image/png'));
            } catch (e) { resolve(null); }
        };
        img.onerror = () => resolve(null);
        img.src = svgToDataUrl(buildQrSvgMarkup(url));
    });

    const shareQR = async () => {
        const url = qrRecord ? recordUrl(qrRecord) : '';
        // Prefer sharing the QR image file via the Web Share API.
        try {
            const dataUrl = await buildQrPngDataUrl(url);
            if (dataUrl && navigator.canShare) {
                const blob = await (await fetch(dataUrl)).blob();
                const file = new File([blob], 'record-qr.png', { type: 'image/png' });
                if (navigator.canShare({ files: [file] })) {
                    await navigator.share({ files: [file], title: 'Record', text: url });
                    return;
                }
            }
        } catch (e) { /* fall through to URL sharing */ }
        // Fallbacks: share the link, else copy it to the clipboard.
        if (navigator.share) {
            try { await navigator.share({ title: 'Record', text: url, url }); return; } catch (e) { /* cancelled */ }
        }
        try { await navigator.clipboard.writeText(url); } catch (e) { /* ignore */ }
    };

    const printQR = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const url = qrRecord ? recordUrl(qrRecord) : '';
        // Embed the QR SVG directly and print via a hidden iframe; CSS sizes it.
        const svgMarkup = buildQrSvgMarkup(url);
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        document.body.appendChild(iframe);
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(
            '<html><head><title>Record QR Code</title>' +
            '<style>svg{width:340px;height:340px;}</style></head>' +
            '<body style="margin:0;text-align:center;font-family:sans-serif;">' +
            '<div style="margin-top:48px;">' + svgMarkup + '</div>' +
            '<p style="font-size:12px;color:#555;word-break:break-all;max-width:360px;margin:12px auto;">' + url + '</p>' +
            '</body></html>'
        );
        doc.close();
        setTimeout(() => {
            try {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            } catch (err) { /* ignore */ }
            setTimeout(() => { try { document.body.removeChild(iframe); } catch (e2) { /* ignore */ } }, 1000);
        }, 150);
    };

    const exportAsPDF = async (e, record1) => {
        setLoading(true);
        let record = await FormService.getRecord(record1.record_id);
        record = record?.record;

        let pages = [];
        let downloadDiv = document.getElementById("downloadDiv");




        var doc = null;

        for (let j = 0; j < record.pages.length; j++) {
            var contentData1 = await contentFor(record, j);
            // downloadDiv.innerHTML = renderToStaticMarkup(contentData1);
            // debugger;
            pages.push(contentData1);
        }

        for (let j = 0; j < record.pages.length; j++) {
            // var contentData1 = await contentFor(record, j);
            // pages.push(contentData1);

            var contentData1 = pages[j];

            downloadDiv.innerHTML = renderToStaticMarkup(contentData1);
            // let height1 = (downloadDiv.scrollHeight - 950) * 0.2645833333;
            // var height2 = document.getElementById("downloadDiv").clientHeight;
            // console.log('height1 > ', downloadDiv.scrollHeight);
            // console.log('height2 > ', height2);
            // let pageHeight = 297;
            // if (downloadDiv.scrollHeight > 1500 && downloadDiv.scrollHeight < 2300) {
            //     pageHeight = pageHeight * 2;
            // }
            // if (downloadDiv.scrollHeight > 2300 && downloadDiv.scrollHeight < 3500) {
            //     pageHeight = pageHeight * 3;
            // }
            // console.log('pageHeight > ', pageHeight);
            // pageHeight = height2 * 0.26458333333719;
            // console.log('pageHeight > ', pageHeight);
            if (j == 0 && doc == null) {
                doc = new jsPDF('p', 'mm', [210, 297]);
            }
            await downloadRecord(doc, j, record.pages.length - 1);
        }
        setPdfPages(pages);
        setLoading(false);
    }

    const deleteRecord = (record, d_type) => {
        if (d_type == 1 || d_type == 2) {
            if (window.confirm('Are you sure want to delete this record?')) {
                setLoading(true);
                FormService.deleteRecord({ "id": record.record_id, "type": d_type }).then(res => {
                    setLoading(false);
                    setTimeout(() => {
                        getRecords("", true);
                    }, 500);
                }).catch(res => {
                    if (res.response.status == 400) {
                        alert(res.response.data.message);
                    }
                    setLoading(false);
                });
            }
        }
        else {
            setLoading(true);
            FormService.deleteRecord({ "id": record.record_id, "type": 0 }).then(res => {
                setLoading(false);
                setTimeout(() => {
                    getRecords("", true);
                }, 500);
            }).catch(res => {
                setLoading(false);
            });
        }
    }

    function downloadRecord(doc, page_num, num_of_pages) {
        return new Promise((res) => {
            let downloadDiv = document.getElementById("downloadDiv");


            html2canvas(downloadDiv).then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                const imgWidth = 210;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;


                if (page_num !== 0) {
                    doc.addPage();
                }
                doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                if (page_num === num_of_pages) {
                    doc.save("record.pdf");
                }
                res(true);
            }).catch(function (error) {
                debugger;
                console.error("domToImage error", error);
                res(true);
            });
        });
    };

    function renderLabelText(text, vars) {
        try {
            let parsedText = text;

            let mathRegex = /\[(.*?)\](\d*)f(\d*)/g;
            let matchResults = [...parsedText.matchAll(mathRegex)];
            matchResults.forEach(result => {
                let mathExp = process_vars(result[1], vars);
                let evaluatedExp = 0;
                try {
                    evaluatedExp = math.evaluate(mathExp).toString();
                    if (result[3] != null) {
                        evaluatedExp = parseFloat(evaluatedExp).toFixed(parseInt(result[3]));
                    }
                } catch (e) {
                    // do nothing
                }
                parsedText = parsedText.replace(result[0], evaluatedExp);
            });

            parsedText = process_vars(parsedText, vars);
            return parsedText;
        } catch (e) {
            return text;
        }
    }

    const exportCSV = async () => {
        try {
            setLoading(true);

            let _formId = formId;

            if (props?.formId != null) {
                _formId = props.formId;
            }

            let payload = {
                formId: _formId,
                page_size: 500,
                csv_fields: csvSelected?.join(","),
            };

            // Existing filters
            if (props?.filters) {
                payload = {
                    ...props.filters,
                    formId: _formId,
                    page_size: 500,
                    csv_fields: csvSelected?.join(","),
                };

                if (payload.flag) {
                    if (Array.isArray(payload.flag)) {
                        payload.flag = payload.flag.join(",");
                    }
                }

                if (props?.formType) {
                    payload.formType = props.formType;
                }
            }

            // Send date filters to Django instead of
            // downloading records and filtering in React.
            if (csvRange?.[0]) {
                payload.created_at__gte = csvRange[0].toISOString();
            }

            if (csvRange?.[1]) {
                payload.created_at__lte = csvRange[1].toISOString();
            }

            const response = await FormService.exportCSV(payload);

            const blob = new Blob(
                [response.data],
                {
                    type: "text/csv;charset=utf-8",
                }
            );

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");

            link.href = url;

            // Get filename from backend if available.
            const contentDisposition =
                response.headers["content-disposition"];

            let filename = "records.csv";

            if (contentDisposition) {
                const match = contentDisposition.match(
                    /filename="?([^"]+)"?/
                );

                if (match?.[1]) {
                    filename = match[1];
                }
            }

            link.setAttribute(
                "download",
                filename
            );

            document.body.appendChild(link);

            link.click();

            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error(
                "CSV export failed:",
                error
            );

            // Add your notification/toast here if needed.

        } finally {
            setLoading(false);
        }
    };

    const exportCSVOld = async () => {
        let _formId = formId;
        if (props?.formId != null) {
            _formId = props?.formId;
        }

        setLoading(true);
        let payload = {
            "formId": formId,
            "formType": props?.formType,
            "page_size": 500,
            "basicRecordInfo": false
        };
        if (props?.filters != null && props?.filters != undefined) {
            payload = props?.filters;
            payload["formId"] = formId;
            payload["basicRecordInfo"] = false;
            payload["page_size"] = 500;
            

            if (payload?.flag != null) {
                if (typeof (payload?.flag) == 'string') {
                    payload["flag"] = payload?.flag;
                }
                else {
                    payload["flag"] = payload?.flag?.join(",");
                }
            }
            payload["formType"] = props?.formType;
        }
        let records = await FormService.getRecords(payload);
        setLoading(false);

        // Restrict to the chosen date range (by record creation time).
        const startMs = (csvRange && csvRange[0]) ? csvRange[0].valueOf() : null;
        const endMs = (csvRange && csvRange[1]) ? csvRange[1].valueOf() : null;
        if ((startMs != null || endMs != null) && records.results) {
            records.results = records.results.filter((r) => {
                const d = new Date(r.created_at).getTime();
                if (startMs != null && d < startMs) return false;
                if (endMs != null && d > endMs) return false;
                return true;
            });
        }

        // Components chosen for inclusion (null = all).
        const selectedNames = csvSelected;

        if (records.results.length > 0) {
            let form_name = records.results[0].form_name;
            let rowsForEachRecord = 1;
            // owners[i] = component name owning column i, or null if always kept.
            let csvFile = ["Ref No.", "Record Name", "Created On", "Last Modified On", "Time Lapsed"];
            let owners = [null, null, null, null, null];

            records.results[0].externals.flags.forEach(flag => {
                let flagName = flag.name.replaceAll(',', '');
                csvFile.push(`Flag: ${flagName}`);
                owners.push(null);
            });

            records.results[0].content.forEach((element, idx) => {
                if (element.type === "intermediate/InputTable") {
                    if (element.data.length > rowsForEachRecord) {
                        rowsForEachRecord = element.data.length;
                    }

                    const key = compKey(element, idx);
                    csvFile.push(element.name.replaceAll(',', ''));
                    owners.push(key);

                    for (let k = 0; k < element.data[0].length; ++k) {
                        csvFile.push(`${element.colData[k].name.replaceAll(',', '')}`);
                        owners.push(key);
                    }
                }
            });

            records.results[0].content.forEach((element, idx) => {
                if (element.type === 'primitive/Input' || element.type === 'primitive/Radio' || element.type === 'primitive/Check' || element.type === 'primitive/Drop') {
                    csvFile.push(element.name.replaceAll(',', ''));
                    owners.push(compKey(element, idx));
                }
                if (element.type === 'primitive/Label' && element?.props?.appearsInCSV) {
                    csvFile.push(element.name.replaceAll(',', ''));
                    owners.push(compKey(element, idx));
                }
            });

            csvFile.push('Record URI');
            owners.push(null);
            csvFile = [csvFile];
            records.results.forEach(inputRecord => {
                let reorderedRecordContent = [[], []]; // first index contains tables, next index contains all else
                inputRecord.content.forEach(element => {
                    if (element.type === 'intermediate/InputTable') {
                        reorderedRecordContent[0].push({ ...element });
                    } else {
                        reorderedRecordContent[1].push({ ...element });
                    }
                });

                let record = {
                    ...inputRecord,
                };

                record.content = reorderedRecordContent[0].concat(reorderedRecordContent[1]);
                let created_at_date = new Date(inputRecord.created_at);
                let updated_at_date = new Date(inputRecord.updated_at);

                const difference_between = (date1, date2) => {
                    let diff = date2 - date1; // in milliseconds
                    let hourDiff = Math.floor(diff / (1000 * 60 * 60));
                    let minuteDiff = Math.floor(diff / (1000 * 60)) - (60 * hourDiff);
                    let secondDiff = Math.floor(diff / (1000)) - (60 * 60 * hourDiff) - (60 * minuteDiff);

                    let hrStr = `${hourDiff}`;
                    let mnStr = `${minuteDiff}`;
                    let scStr = `${secondDiff}`;

                    if (hrStr.length === 1) {
                        hrStr = '0' + hrStr;
                    } if (mnStr.length === 1) {
                        mnStr = '0' + mnStr;
                    } if (scStr.length === 1) {
                        scStr = '0' + scStr;
                    }

                    return `${hrStr}:${mnStr}:${scStr}`;
                };
                let csvRow = [
                    [
                        record.record_id.toString(),
                        record.name.toString().replaceAll(',', ''),
                        '"' + moment(created_at_date).format('lll') + '"',
                        '"' + moment(updated_at_date).format('lll') + '"',
                        '"' + difference_between(created_at_date, updated_at_date) + '"'
                    ]
                ];

                for (let k = 0; k < rowsForEachRecord - 1; ++k) {
                    let rowToPush = [];
                    for (let j = 0; j < owners.length; ++j) {
                        rowToPush.push("");
                    }
                    csvRow.push(rowToPush);
                }

                record.externals.flags.forEach(flag => {
                    csvRow[0].push(`${flag.values[flag.value]}`.replaceAll(',', ''));
                });

                let pushForward = 0;
                for (let k = 0; k < record.content.length; k++) {
                    let k_ = k + pushForward;
                    let element = record.content[k];
                    if (element.type === 'primitive/Input') {
                        csvRow[0].push(element.props.value.replaceAll(',', ''));
                    }
                    else if (element.type === 'primitive/Label' && element?.props?.appearsInCSV) {
                        csvRow[0].push(renderLabelText(element.props.text, inputRecord.vars).replaceAll(',', ''));
                    }
                    else if (element.type === 'primitive/Radio') {
                        try {
                            csvRow[0].push(element.props.content[parseInt(element.props.selected)].replaceAll(',', ''));
                        } catch (e) {
                            csvRow[0].push('');
                        }
                    } else if (element.type === 'primitive/Check') {
                        let checkContent = [];
                        element.props.selected.forEach(id => {
                            checkContent.push(element.props.content[parseInt(id)].replaceAll(',', ''));
                        }); csvRow[0].push(checkContent.join('/'));
                    } else if (element.type === 'primitive/Drop') {
                        try {
                            csvRow[0].push(element.props.content[parseInt(element.props.selected)].replaceAll(',', ''));
                        } catch (e) {
                            csvRow[0].push('');
                        }
                    } else if (element.type === 'intermediate/InputTable') {
                        let currentCol = 5 + records.results[0].externals.flags.length + k_;
                        for (let j = 0; j < element.data.length; ++j) {
                            try {
                                csvRow[j][currentCol] = `Row ${j + 1}`;
                            }
                            catch (e) {
                                // csvRow[j][currentCol] = `Row ${j + 1}`;
                            }
                        }
                        for (let i = 0; i < element.data.length; ++i) {
                            for (let j = 1; j < element.data[0].length + 1; ++j) {
                                if (element.colData[j - 1].type === "Drop") {
                                    try {
                                        csvRow[i][currentCol + j] = element.colData[j - 1].values[element.data[i][j - 1]].replaceAll(',', '');
                                    } catch (e) {
                                        // csvRow[i][currentCol + j] = '';
                                    }
                                } else {
                                    if (element.colData[j - 1].type === "Label") {
                                        try {
                                            csvRow[i][currentCol + j] = renderTableLabelText(record.content, k, element.data[i][j - 1], i, process_table_vars).replaceAll(',', '');
                                        }
                                        catch (e) {

                                        }
                                    } else {
                                        try {
                                            csvRow[i][currentCol + j] = element.data[i][j - 1].toString().replaceAll(',', '');
                                        } catch (e) {
                                            try {
                                                csvRow[i][currentCol + j] = element.data[i][j - 1].toString();
                                            } catch (e) {
                                                //csvRow[i][currentCol + j] = '';
                                            }
                                        }
                                    }

                                }
                            }
                        } pushForward = pushForward + element.data[0].length;
                    }
                }

                csvRow[0].push(
                    `${window.location.href.split('/')[2]}/forms/${formId}/records/${record.record_id}/change`
                );
                for (let k = 0; k < csvRow.length; ++k) {
                    csvFile.push(csvRow[k]);
                }
            });

            // Keep metadata/flag/URI columns (owner null) and selected components.
            const keep = owners.map((o) => o === null || !selectedNames || selectedNames.includes(o));
            const filteredCsv = csvFile.map((row) => {
                const out = [];
                for (let i = 0; i < owners.length; ++i) {
                    if (keep[i]) out.push(row[i] !== undefined ? row[i] : '');
                }
                return out;
            });

            var csv = filteredCsv.map(function (d) {
                return d.join();
            }).join('\n');

            const blob = new Blob([csv], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.download = 'Data for ' + form_name + '.csv';
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }

    const generateCard = (table) => {
        return <Card>
            <CardHeader>
                <CardTitle>
                    Records of <strong>{formName}</strong>
                    <AntdButton style={{ float: 'right' }} type="primary" onClick={(e) => {
                        history.push({
                            pathname: `/forms/${formId}/records/create`
                            // state: location.state
                        });
                    }}>Add New Record</AntdButton>

                    <AntdButton style={{ float: 'right', marginRight: 10 }} onClick={(e) => {
                        history.push('/forms')
                    }} type="primary">Go Back</AntdButton>

                    <AntdButton type="primary" style={{ float: 'right', marginRight: 10 }} onClick={(e) => {
                        e.preventDefault();
                        openCsvOptions();
                    }}>Export Data to CSV</AntdButton>



                </CardTitle>
            </CardHeader>
            <CardBody>
                {table}
            </CardBody>
        </Card >
    }

    const generateTable = () => {


        return <div id="wrapper">
            <div id="downloadDiv1" ref={downloadRef1}></div>
            <div style={{ background: '#fff', position: 'absolute', left: -4000 }}>
                <div id="downloadDiv" ref={downloadRef}></div>
            </div>
            <Table responsive striped hover className="tbl-small">
                <thead>
                    <tr>
                        <th>Ref No.</th>
                        <th>Record Name</th>
                        <th>Created By</th>
                        <th>Create On</th>

                        <th>Last Modified By</th>
                        <th>Last Modified On</th>

                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props?.records?.results?.map((record, index) => {
                            return (
                                <tr key={`record_+${index}`}>
                                    <td>{record?.record_id}</td>
                                    <td>
                                        <span>
                                            {/* return <i className='fa fa-solid fa-flag' key={`flag_${f_indx}`} title={`${flag?.name}: ${flag?.value_text}`} style={{
                                                        fontSize: '1.15vmax',
                                                        color: flag?.colors?.[flag?.value],
                                                        border: '0pt',
                                                        marginRight: '0.5vmax'
                                                    }}></i> */}
                                            {
                                                record?.externals?.flags?.map((flag, f_indx) => {
                                                    return <FlagFilled key={`flag_${f_indx}`} title={`${flag?.name}: ${flag?.value_text}`} style={{
                                                        fontSize: '1.15vmax',
                                                        color: flag?.colors?.[flag?.value],
                                                        border: '0pt',
                                                        marginRight: '0.5vmax'
                                                    }} />
                                                })
                                            }
                                        </span>
                                        {record.name}
                                    </td>

                                    <td>{record.created_by.first_name} {record.created_by.last_name}</td>
                                    <td>{moment(record.created_at).format('lll')}</td>


                                    <td>{record.updated_by?.first_name} {record.updated_by?.last_name}</td>

                                    <td>{moment(record.updated_at).format('lll')}</td>

                                    {
                                        record.is_deleted ? (
                                            <td>

                                                <Dropdown style={{ position: 'absolute', top: 5, right: 5 }}
                                                    trigger={['click']}
                                                    overlay={
                                                        <Menu className="item_menu">
                                                            <Menu.Item key={`1`} onClick={(e) => {
                                                                deleteRecord(record, 0);
                                                            }} > <UndoOutlined /> Restore</Menu.Item>

                                                            <Menu.Item key={`2`} onClick={(e) => {
                                                                deleteRecord(record, 2);
                                                            }}><DeleteOutlined /> Delete</Menu.Item>
                                                        </Menu>
                                                    }>
                                                    <MoreOutlined style={{ fontSize: 20, fontWeight: 'bold' }} />
                                                </Dropdown>
                                            </td>

                                        ) : (
                                            <td>

                                                <Dropdown style={{ position: 'absolute', top: 5, right: 5 }}
                                                    trigger={['click']}
                                                    overlay={

                                                        <Menu className="item_menu">
                                                            <Menu.Item key={`23`} onClick={(e) => {

                                                                history.push({
                                                                    pathname: `/forms/${record.form}/records/${record.record_id}/change`,
                                                                    state: { mode: 'view' }
                                                                });

                                                            }}>View</Menu.Item>
                                                            <Menu.Item key={`3`} onClick={(e) => {

                                                                history.push({
                                                                    pathname: `/forms/${record.form}/records/${record.record_id}/change`,
                                                                    state: { mode: 'edit' }
                                                                });

                                                            }}>Edit</Menu.Item>
                                                            <Menu.Item key={`1`} onClick={(e) => {
                                                                exportAsPDF(e, record);
                                                            }} >Export To PDF</Menu.Item>

                                                            <Menu.Item key={`2`} onClick={(e) => {
                                                                deleteRecord(record, 1);
                                                            }}>Delete</Menu.Item>


                                                            <Menu.Item key={`4`} onClick={(e) => {
                                                                navigator.clipboard.writeText(`${window.location.origin}/forms/${record.form}/records/${record.record_id}/change`)
                                                            }}>Copy Link</Menu.Item>

                                                            <Menu.Item key={`5`} onClick={(e) => {
                                                                setQrRecord(record);
                                                            }}>Generate QR</Menu.Item>

                                                            <Menu.Item key={`6`} onClick={(e) => {
                                                                const url = `${window.location.origin}/forms/${record.form}/records/${record.record_id}/change`;
                                                                setShowDisplayModal(url);
                                                            }}>Send To Display</Menu.Item>
                                                        </Menu>
                                                    }>

                                                    <MoreOutlined style={{ fontSize: 20, fontWeight: 'bold' }} />
                                                </Dropdown>


                                            </td>
                                        )
                                    }


                                </tr>
                            )
                        })
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={6} style={{ textAlign: 'right' }}>
                            <AntdButton type="primary" onClick={() => previous()}>Previous</AntdButton>
                            &nbsp;&nbsp;
                            <AntdButton type="primary" onClick={() => next()}>Next</AntdButton>
                        </td>
                    </tr>
                </tfoot>
            </Table >
        </div >
    }


    const previous = () => {
        getRecords(props?.records.previous, true);
    };

    const next = () => {
        getRecords(props?.records.next, true);
    };

    return (
        <div>
            <Modal
                title={`Send To Display - (Location Code: ${localStorage.getItem('locationCode')})`}
                // width="100%"
                visible={showDisplayModal!=null}
                footer={null}
                onCancel={() => {
                    setShowDisplayModal(null);
                }}
                onClose={() => {
                    setShowDisplayModal(null);
                }}
                onOk={() => {
                    setShowDisplayModal(null);
                }}
                destroyOnClose={true}
            >
                <div style={{ 'margin': '0px auto' }}>
                    <DisplayManager currentUrl={showDisplayModal}/>
                </div>
            </Modal>

            <Modal
                width="100%"
                visible={showPDFModal}
                footer={null}
                onCancel={() => {
                    setShowPDFModal(false);
                }}
            >
                <div style={{ 'margin': '0px auto' }}>
                    {pdfPages}
                </div>
            </Modal>
            <Modal
                title="Record QR Code"
                width={360}
                visible={qrRecord !== null}
                footer={null}
                onCancel={() => setQrRecord(null)}
            >
                {qrRecord ? (
                    <div style={{ textAlign: 'center' }}>
                        <div id="record-qr-wrap" style={{
                            background: '#fff',
                            padding: 16,
                            display: 'inline-block',
                            borderRadius: 8
                        }}>
                            <QRCode value={recordUrl(qrRecord)} size={220} />
                        </div>
                        <p style={{
                            wordBreak: 'break-all',
                            fontSize: 12,
                            color: '#8a8a8a',
                            margin: '14px 0 18px'
                        }}>{recordUrl(qrRecord)}</p>
                        <div>
                            <AntdButton type="primary" onClick={printQR}>Print</AntdButton>
                            &nbsp;&nbsp;
                            <AntdButton onClick={shareQR}>Share</AntdButton>
                        </div>
                    </div>
                ) : null}
            </Modal>
            <Modal
                title="Export CSV"
                width={460}
                visible={showCsvOptions}
                onCancel={() => setShowCsvOptions(false)}
                okText="Export"
                onOk={() => { exportCSV(); setShowCsvOptions(false); }}
            >
                <div style={{ marginBottom: 16 }}>
                    <div style={{ fontWeight: 500, marginBottom: 6 }}>Date range (optional)</div>
                    <DatePicker.RangePicker
                        showTime
                        value={csvRange}
                        onChange={(range) => setCsvRange(range)}
                        style={{ width: '100%' }}
                    />
                </div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                        <span style={{ fontWeight: 500 }}>Pages &amp; components to include</span>
                        {csvComponents.length > 0 ? (() => {
                            const allKeys = csvComponents.map((c) => c.key);
                            const allSelected = allKeys.every((k) => (csvSelected || []).includes(k));
                            return (
                                <AntdButton type="link" size="small" style={{ padding: 0 }}
                                    onClick={() => toggleCsvKeys(allKeys, !allSelected)}>
                                    {allSelected ? 'Unselect All Pages' : 'Select All Pages'}
                                </AntdButton>
                            );
                        })() : null}
                    </div>
                    {csvComponents.length === 0 ? (
                        <div style={{ color: '#999', border: '1px solid #f0f0f0', borderRadius: 6, padding: '12px' }}>
                            No exportable components.
                        </div>
                    ) : (
                        <div style={{ border: '1px solid #f0f0f0', borderRadius: 6, overflow: 'hidden' }}>
                            {/* Page tabs (horizontally scrollable). The checkbox toggles the
                                whole page; clicking the tab body opens it below. */}
                            <div style={{ display: 'flex', overflowX: 'auto', borderBottom: '1px solid #f0f0f0', background: '#fafafa' }}>
                                {[...new Set(csvComponents.map((c) => c.page))].sort((a, b) => a - b).map((pg) => {
                                    const pageComps = csvComponents.filter((c) => c.page === pg);
                                    const sel = csvSelected || [];
                                    const allOn = pageComps.every((c) => sel.includes(c.key));
                                    const someOn = pageComps.some((c) => sel.includes(c.key));
                                    const isActive = activeCsvPage === pg;
                                    return (
                                        <div key={pg}
                                            onClick={() => setActiveCsvPage(pg)}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: 6,
                                                padding: '8px 14px', cursor: 'pointer', whiteSpace: 'nowrap',
                                                borderBottom: isActive ? '2px solid #1777ff' : '2px solid transparent',
                                                color: isActive ? '#1777ff' : '#333',
                                                fontWeight: isActive ? 600 : 400,
                                                background: isActive ? '#fff' : 'transparent',
                                            }}>
                                            <Checkbox
                                                checked={allOn}
                                                indeterminate={someOn && !allOn}
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={(e) => toggleCsvKeys(pageComps.map((c) => c.key), e.target.checked)}
                                            />
                                            Page {pg + 1}
                                        </div>
                                    );
                                })}
                            </div>
                            {/* Components of the active page. */}
                            <div style={{ maxHeight: 220, overflowY: 'auto', padding: '8px 12px' }}>
                                {csvComponents.filter((c) => c.page === activeCsvPage).map((c) => (
                                    <div key={c.key} style={{ padding: '2px 0' }}>
                                        <Checkbox
                                            checked={(csvSelected || []).includes(c.key)}
                                            onChange={(e) => toggleCsvKeys([c.key], e.target.checked)}
                                        >{c.label}</Checkbox>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
            {
                loading ? (
                    <div className="blockUI">
                        <div className="loading-icon-container">
                            <LoadingOutlined />
                            <br />
                            <br />
                            <strong>Loading...</strong>
                        </div>
                    </div>
                ) : null
            }
            {
                props?.withCard ? generateTable() : generateCard(generateTable())
            }
        </div>

    );
}

function mapStateToProps(state) {
    const { records } = state.forms;
    const { user } = state.auth;
    return {
        records,
        user
    }
}
export default connect(mapStateToProps)(Records);